<template>
    <portal to="modal" v-if="show">
        <Modal :show="show" fullscreen :closeOnBackdropClick="false" @onModalClose="handleClose">
            <div class="Upgrade">
                <h1 class="Upgrade-Title">Wählen Sie Ihr Paket</h1>
                <h3 class="Upgrade-Subtitle">Finden Sie die perfekte Lösung für Ihre Flotte</h3>

                <Pricing :planType="planType" :isMarketing="false" @onUpgrade="handleUpgrade" />

                <div class="Upgrade-Info">
                    <p class="InfoText">
                        <i class="ri-information-line"></i>
                        Alle Preise verstehen sich zzgl. MwSt. Kündigung ist monatlich möglich.
                    </p>
                </div>
            </div>
        </Modal>
    </portal>
</template>

<script>
import { mapGetters } from 'vuex';
import { Portal } from 'portal-vue';
import Modal from '@/components/widgets/Modal.vue';
import Pricing from '@/components/Pricing.vue';

export default {
    name: 'UpgradeModal',
    components: {
        Portal,
        Modal,
        Pricing,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            billingPeriod: 'monthly',
        };
    },
    computed: {
        ...mapGetters(['planType', 'user']),
    },
    methods: {
        handleClose() {
            this.$emit('onClose');
        },
        handleUpgrade(targetPlan) {
            this.$toasted?.show(`${targetPlan.toUpperCase()} Tarif wird aktiviert...`, {
                type: 'info',
            });
            this.$emit('onUpgrade', targetPlan);
        },
    },
    mounted() {
        this.$emit('onFinishLoading');
    },
};
</script>

<style lang="scss" scoped>
.Upgrade {
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;

    @media (max-width: $breakpoint-tablet-portrait) {
        padding: 20px 15px;
    }
}

.Upgrade-Header {
    margin: 0;

    @media (max-width: $breakpoint-tablet-portrait) {
        margin: 0;
    }
}

.Upgrade-Title {
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--color-text-black);
    margin: 10px 0 0px 0;
    text-align: center;
}

.Upgrade-Subtitle {
    font-size: 1rem;
    color: var(--color-text-black);
    margin: 0 0 20px 0;
    font-weight: 400;
    text-align: center;
}

.BillingToggle {
    display: flex;
    justify-content: center;
    gap: 0;
    background: var(--color-hover);
    border-radius: 8px;
    padding: 4px;
    margin: 0 auto 50px;
    max-width: 400px;

    .Toggle-Option {
        flex: 1;
        padding: 10px 20px;
        border: none;
        background: transparent;
        border-radius: 6px;
        font-size: 0.95rem;
        font-weight: 500;
        color: var(--color-text-gray-dark);
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;

        &:hover {
            color: var(--color-text-black);
        }

        &.active {
            background: var(--color-white);
            color: var(--color-text-black);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .Save-Badge {
            font-size: 0.75rem;
            background: var(--color-red);
            color: var(--color-text-white);
            padding: 2px 8px;
            border-radius: 12px;
            font-weight: 600;
        }
    }
}

.Upgrade-Info {
    text-align: center;
    margin-top: 20px;
}

.InfoText {
    font-size: 0.8125rem !important;
    color: var(--color-text-gray-darker);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin: 0;
}
</style>
